import React from 'react';
import {Box, VStack, Text, HStack, Avatar, AvatarGroup, useTheme} from '@chakra-ui/react';
import { TextG16, TextG32 } from '../../components/typography';
import HeaderImage from '../../assets/images/onboardingPic.png';

const IntroWelcome = () => {
  const theme = useTheme();

  return (
    <VStack
      flex={1}
      spacing={8}
      px={4}
      pb={4}
      align="center"
      justify="center"
      overflow="auto">
      {/* Circular Video/Image Container */}
      <Box position="relative" minW="270px" minH="270px">
        {/* TODO: Replace with actual video when available */}
        {/* For now using a placeholder that can be replaced with video element */}
        <Box
          w="100%"
          h="100%"
          borderRadius="full"
          overflow="hidden"
          bg={theme.colors.gray[200]}
          position="relative">
          {/* Placeholder for video - will be replaced with actual video */}
          <Box
            as="img"
            src={HeaderImage}
            alt="Community gathering"
            w="100%"
            h="100%"
            objectFit="cover"
          />
          {/* Uncomment when video is available:
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}>
            <source src="/path/to/community-video.mp4" type="video/mp4" />
          </video>
          */}
        </Box>

        {/* Avatar Group Badge */}
        <Box
          position="absolute"
          bottom="0px"
          left="50%"
          transform="translateX(-50%)"
          bg="#FFF"
          paddingLeft="8px"
          paddingRight="16px"
          paddingTop="8px"
          paddingBottom="8px"
          borderRadius="100px"
          border="2px solid #E9E9E9"
          display="inline-flex"
          alignItems="center"
          gap="12px">
          <AvatarGroup size="sm" max={3} spacing="-10px">
            <Avatar
              name="User 1"
              src="https://i.pravatar.cc/150?img=1"
              border="2px solid white"
              w="32px"
              h="32px"
            />
            <Avatar
              name="User 2"
              src="https://i.pravatar.cc/150?img=2"
              border="2px solid white"
              w="32px"
              h="32px"
            />
            <Avatar
              name="User 3"
              src="https://i.pravatar.cc/150?img=3"
              border="2px solid white"
              w="32px"
              h="32px"
            />
          </AvatarGroup>
          <TextG16 fontWeight="700" color="#202020" whiteSpace="nowrap">
            14k+ San Diegans have joined
          </TextG16>
        </Box>
      </Box>

      {/* Title */}
      <VStack spacing={1} textAlign="center" maxW="100%" pt={4}>
        <TextG32 fontSize="32px" fontWeight="700" lineHeight="1.2" color={theme.colors.gray[900]}>
          Meet neighbors
        </TextG32>
        <TextG32 fontSize="32px" fontWeight="700" lineHeight="1.2" color={theme.colors.gray[900]}>
          Make friends
        </TextG32>
        <TextG32 fontSize="32px" fontWeight="700" lineHeight="1.2" color="#C9136B">
          Build true community
        </TextG32>
      </VStack>
    </VStack>
  );
};

export default IntroWelcome;
